import { BehaviorSubject, Observable } from 'rxjs';
import { UserModel } from '../Models/Auth/UserModel';
import { UserHelper } from '../Helpers/UserHelper';
import { authService, serviceBundler, webSocketService } from '../App';
import { AxiosResponse } from 'axios';
import { HttpHelper } from '../Helpers/HttpHelper';
import { t } from 'i18next';
import { WsRequestActiveNotifications } from '../Models/WebSocket/Outgoing/WsRequestActiveNotifications';
import { HelperHelper } from '../Helpers/HelperHelper';

export class CoreService {
  private FetchingReadySubject: BehaviorSubject<boolean>;
  private FetchingReady!: boolean;

  private lastOnline: boolean = true;
  private connectionLost: boolean = false;
  private notificationShown: boolean = false;

  private timeBeforeRemove: number = 3;
  private resultIpAddress: string = '';

  public users!: Array<UserModel>;
  constructor() {
    this.FetchingReadySubject = new BehaviorSubject<boolean>(false);
    this.GetFetchStatus();

    var intervalId = window.setInterval(() => {
      this.RefreshWebsite();
      this.handleOfflineApi();
      this.handleOfflineWebSocket();
    }, 60000);

    var intervalId = window.setInterval(() => {
      this.RefreshWebsite();
    }, 1000);
  }

  public async CheckServiceIsOnline() {
    if (await serviceBundler.coreService.IsScreenDevice()) {
      this.timeBeforeRemove = 15;
    }

    var now = new Date().getTime() / 1000;
    var lastOnline =
      new Date(webSocketService.GetLatestMessageTimeStamp()).getTime() / 1000;
    if (
      lastOnline + this.timeBeforeRemove <= now ||
      lastOnline === undefined ||
      isNaN(lastOnline)
    ) {
      this.connectionLost = true;
      return false;
    }
    if (this.connectionLost) {
      this.connectionLost = false;
      webSocketService.sendMessage(new WsRequestActiveNotifications());
    }
    return true;
  }

  public ShowNotification(show: boolean) {
    this.notificationShown = show;
  }

  public IsNotificationShown() {
    return this.notificationShown;
  }

  private RefreshWebsite() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    if (hours === 0 && minutes === 0) {
      location.reload();
    }

    if (hours === 7 && minutes === 15) {
      location.reload();
    }
  }

  private async FetchItems() {
    var token = authService.GetToken();


    if (!this.FetchingReady) {
      this.FetchingReady = true;
      this.FetchingReadySubject.next(true);
    }
  }

  public GetFetchStatus(): Observable<boolean> {
    this.FetchItems();
    return this.FetchingReadySubject.asObservable();
  }

  private handleOfflineApi = async () => {
    const isOnline = await this.checkRealConnection();

    if (isOnline && !this.lastOnline) {
      this.lastOnline = true;

      window.location.reload();
    } else if (!isOnline) {
      this.lastOnline = false;
    }
  };

  private handleOfflineWebSocket = async () => {
    const isOnline = webSocketService.IsConnected();
    if (!isOnline) {
      window.location.reload();
    }
  };

  private async checkRealConnection(): Promise<boolean> {
    try {
      const response = await HttpHelper.GetRequestForApi(
        HttpHelper.GetUrlBaseApi() + 'api/Helper/Alive',
      );

      if (response === undefined) {
        return false;
      }
      return true;
    } catch {
      return false;
    }
  }

  public async IsScreenDevice(){
    if (this.resultIpAddress === '') {
      this.resultIpAddress = await this.GetIpAddress();
    }

    if (this.resultIpAddress === '192.168.2.205') {
      return true;
    } 
    return false;
  }

  private async GetIpAddress(): Promise<string> {
      const response = await HelperHelper.GetIpAddress();
      return response;
  }

  eraseCache() {}

  public dispose() {}
}
